import { $Locale, $Traffic } from '@lemon8/webapp-shared/model';
import { EURO_COUNTRY_SET } from '@lemon8/webapp-shared/i18n';
import { atom } from 'jotai';

export const $EnablePintrk = atom((get) => {
  const { region, ipRegion } = get($Locale);
  const { href } = get($Traffic);

  return (
    (href.includes('pid=pinterest_int') || href.includes('pid=US_pinterest')) &&
    region === 'us' &&
    !EURO_COUNTRY_SET.has(ipRegion)
  );
});
